import { useEffect, useState } from 'react';
import { getAdvertisements } from '~kup/controllers/advertisement.ts';
import Advertisement from '~kup/models/Advertisement.ts';

export default function useAdvertisements(type: Advertisement['bannerType'] = 'BASIC') {
  const [advertisements, setAdvertisements] = useState<Advertisement[] | null>(null);
  useEffect(() => {
    getAdvertisements(type)
      .then((res) => {
        setAdvertisements(res.filter((ad) => ad.banners.length > 0));
      })
      .catch(console.error);
  }, [type]);

  return advertisements;
}
